import { render } from "./clinic-patient-search.vue?vue&type=template&id=b5b6407c&scoped=true"
import script from "./clinic-patient-search.vue?vue&type=script&lang=js"
export * from "./clinic-patient-search.vue?vue&type=script&lang=js"

import "./clinic-patient-search.vue?vue&type=style&index=0&id=b5b6407c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b6407c"]])

export default __exports__